import React, { useState } from "react";
import { Modal, Table, Button, notification } from "antd";
import dayjs from "dayjs";
import axiosInstance from "utilities/axios";
import { useEffect } from "react";

const RegionHistory = ({ region }) => {
  const [visible, setVisible] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`/regions/${region.regionCode}/history`)
      .then((response) => {
        setHistory(response.data);  
      })
      .catch((error) => {
        notification.error({
          message: "Failed to fetch Region History",
          description: error.response.data.error,
        });
      });
  }, [region])

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: "20%",
      sorter: (a, b) => dayjs(a.date).unix() - dayjs(b.date).unix(),
      defaultSortOrder: "descend",
    },
    {
      title: "Change",
      dataIndex: "",
      key: "x",
      width: "80%",
      render: (text, record) => (
        <>
          {record.type === "start" && (
            <>
              {record.initials ? (
                <p>{record.firstName} {record.lastName} has become a {record.title}</p>
              ) : (
                <p>Clinic {record.clinicNo} has been added to this region</p>
              )}
            </>
          )}

          {record.type === "end" && (
            <>
              {record.initials ? (
                <p>{record.firstName} {record.lastName} has been removed as a {record.title}</p>
              ) : (
                <p>Clinic {record.clinicNo} has been removed and added to Region {record.regionCode}</p>
              )}
            </>
            
          )}
        </>
      ),
    },
  ];

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  return (
    <>
      <Button type="link" onClick={showModal}>
        Show Region History
      </Button>
      <Modal
        title="Region History"
        open={visible}
        okText="Close"
        onOk={handleOk}
        cancelButtonProps={{ style: { display: "none" } }}
        onCancel={() => setVisible(false)}
        width="50vw"
      >
        <Table 
          columns={columns}
          dataSource={history}
          pagination={true}
          scroll={{
            y: "40vh",
          }}
        />
      </Modal>
    </>
  );
};

export default RegionHistory;
